import { atom } from 'jotai';

import { QuoteCurrencyListExceptUsdt } from '@flipster/utils/constants/currency';
import { mapToObj } from '@flipster/utils/map-to-obj';

// USDT 외 quote currency 의 마켓 탭·캐러셀 어트리뷰션 코드.
// 통화 코드를 템플릿에 끼워 만드는 규약이라 큐레이션 목록에 통화를 추가하면 코드가 자동 생성된다.
// 목록이 비면 빈 객체이므로 기존 키의 리터럴 타입도 보존된다.
const quoteCurrencyCategoryAttributions = mapToObj(
  QuoteCurrencyListExceptUsdt,
  (currency) => `MARKET_CATEGORIES_${currency}_PAIRS`,
);
const quoteCurrencyDiscoverAttributions = mapToObj(
  QuoteCurrencyListExceptUsdt,
  (currency) => `MARKET_DISCOVER_${currency}_PAIRS`,
);

export const OrderAttributionMapper = {
  trade: {
    recentHistory: 'SEARCH_RECENT_HISTORY',
    search: 'SEARCH',
    all: 'SEARCH_ALL',
    favorites: 'SEARCH_FAVORITES',
    positionsOpened: 'SEARCH_POSITIONS_OPENED',
    perpetual: 'SEARCH_PERPETUAL',
    spot: 'SEARCH_SPOT',
    spotDefault: 'TRADE_SPOT_DEFAULT',
    perpetualDefault: 'TRADE_PERPETUAL_DEFAULT',
    hotTradings: 'SEARCH_HOT',
    newListings: 'SEARCH_NEW',
    yourFrequentTrades: 'SEARCH_FREQUENT_TRADES',
    tradFi: 'SEARCH_TRADFI',
  },
  market: {
    search: 'MARKET_SEARCH',
    searchRecentHistory: 'MARKET_SEARCH_RECENT_HISTORY',
    carouselZeroSpread: 'CAROUSEL_ZERO_SPREAD',
    categories: {
      yourHoldings: 'MARKET_CATEGORIES_YOUR_HOLDINGS',
      hotTradings: 'MARKET_CATEGORIES_HOT_TRADING_PAIRS',
      newListings: 'MARKET_CATEGORIES_NEW_LISTINGS',
      priceChange24h: 'MARKET_CATEGORIES_TOP_MOVERS',
      volume: 'MARKET_CATEGORIES_HIGH_VOLUME',
      absFundingRates: 'MARKET_CATEGORIES_HIGH_FUNDING_RATES',
      yourFrequentTrades: 'MARKET_CATEGORIES_YOUR_FREQUENT',
      ...quoteCurrencyCategoryAttributions,
      tradfi: 'MARKET_CATEGORIES_TRADFI',
      tradfiAll: 'MARKET_CATEGORIES_TRADFI',
      tradfiPreIpo: 'MARKET_CATEGORIES_TRADFI',
      tradfiStocks: 'MARKET_CATEGORIES_TRADFI',
      tradfiEtf: 'MARKET_CATEGORIES_TRADFI',
      tradfiCommodity: 'MARKET_CATEGORIES_TRADFI',
    },
    discover: {
      favorites: 'MARKET_DISCOVER_FAVORITES',
      marketCap: 'MARKET_DISCOVER_ALL',
      hotTradings: 'MARKET_DISCOVER_HOT_TRADINGS',
      newListings: 'MARKET_DISCOVER_NEW_LISTINGS',
      priceChange24h: 'MARKET_DISCOVER_TOP_MOVERS',
      volume: 'MARKET_DISCOVER_HIGH_VOLUMES',
      absFundingRates: 'MARKET_DISCOVER_HIGH_FUNDING_RATES',
      yourFrequentTrades: 'MARKET_DISCOVER_FREQUENT_TRADES',
      ...quoteCurrencyDiscoverAttributions,
      tradfi: 'MARKET_DISCOVER_TRADFI',
    },
    topTradersOpenPositions: (profileId?: string) =>
      `MARKET_TOP_TRADERS_OPEN_POSITIONS${profileId ? `:${profileId}` : ''}`,
  },
  earn: {
    extraApr: 'EARN_EXTRA_APR',
    earnIncreaseLimit: 'EARN_INCREASE_LIMIT',
    earnTraders: 'EARN_TRADERS',
    earnTradingBonusNudge: 'EARN_TRADING_BONUS_NUDGE',
  },
  asset: {
    assetSpotTrade: 'ASSET_SPOT_TRADE',
    assetPerpTrade: 'ASSET_PERP_TRADE',
    assetPerpPositionSymbol: 'ASSET_PERP_POSITION_SYMBOL',
  },
  profile: {
    performance: (profileId?: string) => `PROFILE_PERFORMANCE${profileId ? `:${profileId}` : ''}`,
    tradingActivity: (profileId?: string) => `PROFILE_TRADING_ACTIVITY${profileId ? `:${profileId}` : ''}`,
    socialFeedPosition: (profileId?: string) => `PROFILE_SOCIAL_FEED_POSITION${profileId ? `:${profileId}` : ''}`,
  },
  vip: {
    vipTradeRebate: 'VIP_TRADE_REBATE',
  },
  leaderboard: {
    weeklyPnlTrade: 'WEEKLY_PNL_TRADE',
  },
  profitBoost: {
    profitBoostPage: 'PROFIT_BOOST_PAGE',
  },
  zeroSpread: {
    zeroSpreadPage: 'ZERO_SPREAD_PAGE',
  },
};

export const orderAttributionAtom = atom<string | undefined>(undefined);
